import {
  DEFAULT_AUTOCOMPLETE_CLASS_NAME,
  ONBOARDING_AUTOCOMPLETE_CLASS_NAME,
} from '../../constants/autocomplete';

const defaultFingoAutocomplete = () => ({});

const onboardingFingoAutocomplete = ({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    padding: '16px 24px',
    backgroundColor: theme.palette.gray.A100,
  },
  '& .MuiOutlinedInput-input': {
    backgroundColor: theme.palette.gray.A100,
    fontSize: theme.typography.medium_1.fontSize,
    [theme.breakpoints.down('md')]: {
      fontSize: theme.typography.small_2.fontSize,
    },
    color: theme.palette.gray.A500,
    '&::placeholder': {
      opacity: 1,
    },
  },
  '& .MuiAutocomplete-popupIndicator': {
    color: theme.palette.primary.main,
  },
  '& .MuiAutocomplete-inputRoot': {
    border: `2px solid ${theme.palette.gray.A300}`,
    backgroundColor: theme.palette.gray.A100,
    borderRadius: '16px',
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: '8px',
      border: 'none',
    },
    '&:hover': {
      borderColor: theme.palette.primary.main,
    },
    '&.Mui-focused': {
      borderColor: theme.palette.primary.main,
    },
  },
  '& .MuiAutocomplete-listbox': {
    backgroundColor: '#fffbe6', // Color de fondo personalizado
    borderRadius: 16,
    boxShadow: '0px 2px 8px rgba(0,0,0,0.08)',
  },
  '& .MuiAutocomplete-paper': {
    margin: '8px', // Margen personalizado para el Paper
  },
});

const MuiAutocomplete = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`&.${DEFAULT_AUTOCOMPLETE_CLASS_NAME}`]: defaultFingoAutocomplete({ theme }),
      [`&.${ONBOARDING_AUTOCOMPLETE_CLASS_NAME}`]: onboardingFingoAutocomplete({ theme }),
    }),
  },
};

export default MuiAutocomplete;
